/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Trans } from "react-i18next";
import { Tab, Nav } from "react-bootstrap";
import Pagination from "react-js-pagination";
import requireAuth from "components/hoc/requireAuth";
import { showModal, getGuide } from "actions";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import GuideCard from "components/guide/GuideCard";
import Helpers from "util/helpers";
import GuideManagers from "components/guide/GuideManagers";
import i18n from "i18next";
import GuidePlatin from "./GuidePlatin";

class Guide extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // guideFetched: false,
      guideFetched: false,
      currentTab: "#personel",
      searchTerm: "",
      selectedDepartment: "all",
      isOtosanContact: false,
      selectedManager: null,
      activePage: 1,
      filteredData: null,
      searchOtosanDepartmentsTerm: "all",
      showOtosanDepartments: false,
      otosanDepartmentDropdownFocused: false,
      design: false,
    };
    this.settings = {
      itemsPerPage: 10,
    };

    this.otosanDepartmentsRef = React.createRef();
    this.distinctOtosanDepartments = [];
    this.distinctDealerDepartments = [];
    document.addEventListener("click", this.handleClickOutside);
  }

  componentDidMount() {
    if (this.props.guide.data.length === 0) {
      this.fetchData();
    } else this.onFetchSuccess();
  }

  fetchData = () => {
    this.props.getGuide(
      5000,
      this.onFetchBegin,
      this.onFetchSuccess,
      this.onFetchError
    );
  };

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  componentDidUpdate = (prevProps, prevState) => {

    if (prevState.filteredData) {
      if (this.state.searchTerm.length < 4) return null;
      let fixedSearchTerm = Helpers.getTurkishCharaterFixedList(
        this.state.searchTerm,
        []
      );
      let isOtosanContact = this.state.isOtosanContact;
      let filteredData = this.props.guide.data
        .filter((c) => c.isOtosanContact === isOtosanContact)
        .filter((contact) => {
          if (!contact.fullname) return false;
          let fixedName = Helpers.getTurkishCharaterFixedList(contact.fullname);
          let splittedName = fixedName.split(" ");

          for (let i = 0; i < splittedName.length; i++) {
            if (!fixedSearchTerm.includes(" ")) {
              if (splittedName[i].startsWith(fixedSearchTerm)) return true;
            } else {
              // search in all name combinations
              let nameCombinations = Helpers.combine(splittedName, 1);
              for (let i = 0; i < nameCombinations.length; i++) {
                if (nameCombinations[i].join(" ").startsWith(fixedSearchTerm))
                  return true;
              }
            }
          }
          return false;
        })
        .filter((c) => {
          return this.state.selectedDepartment !== "all"
            ? c.department === this.state.selectedDepartment
            : true;
        });
      // .filter((c) => {
      //   return this.state.selectedManager
      //     ? c.reportManager
      //       ? c.reportManager.id === this.state.selectedManager
      //       : false
      //     : true;
      // })

      if (!_.isEqual(filteredData.sort(), prevState.filteredData.sort())) {
        this.setState({ filteredData });
      }
    }
  };

  onFetchBegin = () => {
    this.props.onProcessBegin();
  };

  onFetchError = (err) => {
    console.log(err);
    this.props.onProcessEnd();
  };

  onFetchSuccess = () => {
    this.props.onProcessEnd();
    let filteredData = [...this.props.guide.data].filter(
      (c) => c.isOtosanContact === false
    );
    // let distinctOtosanDepartments = [
    //   ...new Set(
    //     this.props.guide.data
    //       .filter((c) => c.isOtosanContact === true)
    //       .map((c) => c.department)
    //   ),
    // ];

    // this.distinctOtosanDepartments = distinctOtosanDepartments.map((dod) => {
    //   return {
    //     key: dod,
    //     text: dod,
    //     value: dod,
    //   };
    // });

    this.distinctOtosanDepartments = [
      ...new Set(
        this.props.guide.data
          .filter((c) => c.isOtosanContact === true)
          .map((c) => c.department)
      ),
    ];

    // console.log(distinctOtosanDepartments);

    this.distinctDealerDepartments = [
      ...new Set(
        this.props.guide.data
          .filter((c) => c.isOtosanContact === false)
          .map((c) => c.department)
      ),
    ];

    this.setState({
      guideFetched: true,
      isOtosanContact: false,
      filteredData,
    });
  };

  handleClickOutside = (e) => {
    // console.dir(this.otosanDepartmentsRef.current);
    // console.dir(e.target);
    if (
      !(
        this.otosanDepartmentsRef.current &&
        this.otosanDepartmentsRef.current.contains(e.target)
      )
    )
      this.handleOtosanDepartmentComboFocus(e, false);
  };

  handlePageChange = (e) => {
    this.setState({ activePage: e });
  };

  handleTabSelected = (selected) => {
    let isOtosanContact = true;
    if (selected === "#personel") isOtosanContact = false;
    this.setState({
      searchTerm: "",
      selectedDepartment: "all",
      searchOtosanDepartmentsTerm: "all",
      showOtosanDepartments: false,
      isOtosanContact,
      activePage: 1,
      selectedManager: null,
    });
  };

  handleOtosanDepartmentComboFocus = (e, focused) => {
    this.setState({
      searchOtosanDepartmentsTerm: "",
      otosanDepartmentDropdownFocused: focused,
    });

    // e.stopPropagation();
  };

  handleKeywordSearch = (e) => {
    this.setState({ searchTerm: e.target.value });
  };

  handleDepartmentSelect = (e) => {
    if (e.target.value === "") this.setState({ selectedDepartment: "all" });
    else {
      this.setState({ selectedDepartment: e.target.value });
    }
  };

  handleDepartmentSearch = (e) => {
    if (e.target.value === "")
      this.setState({
        selectedDepartment: "all",
        searchOtosanDepartmentsTerm: "all",
        showOtosanDepartments: false,
        activePage: 1,
      });
    else {
      this.setState({
        searchOtosanDepartmentsTerm: e.target.value,
        selectedDepartment: e.target.value,
        showOtosanDepartments: true,
        activePage: 1,
      });
    }
  };

  handleOtosanDepartmentSelect = (e, d) => {
    this.setState({
      selectedDepartment: d,
      showOtosanDepartments: false,
      searchOtosanDepartmentsTerm: d,
      activePage: 1,
      otosanDepartmentDropdownFocused: false,
    });
  };

  getContact = (cid) => {
    let result = null;
    const contact = this.props.guide.data.find((c) => c.id === cid);
    if (contact) {
      result = {
        fullname: contact.fullname,
        department: contact.department,
        position: contact.position,
      };
    }

    return result;
  };

  getFullContact = (cid) => {
    return this.props.guide.data.find((c) => c.id === cid);
  };

  renderPager = () => {
    return (
      <div
        style={{
          display: "grid",
          justifyContent: "right",
          marginRight: "20px",
        }}
      >
        <Pagination
          hideFirstLastPages={false}
          prevPageText="Önceki"
          nextPageText="Sonraki"
          hideDisabled={true}
          activePage={this.state.activePage}
          itemsCountPerPage={this.settings.itemsPerPage}
          totalItemsCount={
            this.state.filteredData ? this.state.filteredData.length : 0
          }
          onChange={(e) => this.handlePageChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        />
      </div>
    );
  };

  renderKeywordSearch = () => {
    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-xl-1 py-xl-0 pr-lg-1 py-lg-0 pr-md-1 py-md-0 p-sm-2 py-sm-0 px-2 pb-2">
        <div className="inner-addon right-addon">
          <span className="iconmford fo-icon-search"></span>
          <input
            type="text"
            name="findContact"
            className="form-control"
            placeholder={i18n.t("10053")}
            onChange={(e) => this.handleKeywordSearch(e)}
            value={this.state.searchTerm}
            autoComplete="off"
          />
        </div>
      </div>
    );
  };

  renderOtosanDistinctDepartments = () => {
    if (!this.state.otosanDepartmentDropdownFocused) return null;

    // if (
    //   this.state.searchOtosanDepartmentsTerm === "all" ||
    //   this.state.searchOtosanDepartmentsTerm === "" ||
    //   this.state.showOtosanDepartments === false
    // )
    //   return null;

    let fixedSearchTerm = Helpers.getTurkishCharaterFixedList(
      this.state.searchOtosanDepartmentsTerm
    );
    if (this.state.searchOtosanDepartmentsTerm === "all") fixedSearchTerm = "";

    return (
      <>
        {/* <OutsideClickAware
          handleClickOutside={(e) =>
            this.handleOtosanDepartmentComboFocus(e, false)
          }
        > */}
        <div>
          <table
            className="table table-bordered guideSearchResultMain"
            id="guideSearchResult"
            style={{
              display: "table",
              width: "450px",
              position: "absolute",
              zIndex: "10",
            }}
          >
            <tbody
              style={{
                display: "inline-block",
                overflowY: "scroll",
                maxHeight: "500px",
                zIndex: "2",
              }}
            >
              {this.distinctOtosanDepartments
                .filter((d) => {
                  let fixedName = Helpers.getTurkishCharaterFixedList(d);
                  let splittedName = fixedName.split(" ");

                  for (let i = 0; i < splittedName.length; i++) {
                    if (!fixedSearchTerm.includes(" ")) {
                      if (splittedName[i].startsWith(fixedSearchTerm))
                        return true;
                    } else {
                      // search in all name combinations
                      let nameCombinations = Helpers.combine(splittedName, 1);
                      for (let i = 0; i < nameCombinations.length; i++) {
                        if (
                          nameCombinations[i]
                            .join(" ")
                            .startsWith(fixedSearchTerm)
                        )
                          return true;
                      }
                    }
                  }
                  return false;
                })
                .map((d) => {
                  return (
                    <tr
                      key={d}
                      // style={{ background: "#ffffff" }}
                      onClick={(e) => this.handleOtosanDepartmentSelect(e, d)}
                    >
                      <td>{d}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        {/* </OutsideClickAware> */}
      </>
    );
  };

  renderDepartmentFilter = () => {
    let isOtosanContact = this.state.isOtosanContact;

    if (!isOtosanContact) {
      return (
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 pl-xl-1 py-xl-0 pl-lg-1 py-lg-0 pl-md-1 py-md-0 p-sm-2 py-sm-0 px-2 pb-1">
          <div className="inner-addon right-addon">
            <select
              className="custom-select"
              id="egitimDurumu"
              onChange={(e) => this.handleDepartmentSelect(e)}
              value={this.state.selectedDepartment}
            >
              <option value="all">{i18n.t("10046")}</option>
              {this.distinctDealerDepartments.map((dd) => (
                <option key={dd} value={dd}>
                  {dd}
                </option>
              ))}
            </select>
          </div>
        </div>
      );
    } else {
      return (
        <div
          className="col-xs-12 col-sm-12 col-md-12 col-lg-12 pl-xl-1 py-xl-0 pl-lg-1 py-lg-0 pl-md-1 py-md-0 p-sm-2 py-sm-0 px-2 pb-1"
          style={{ zIndex: "500" }}
          ref={this.otosanDepartmentsRef}
        >
          <div className="inner-addon right-addon">
            <span className="icon-icon-table-dropdown" style={{ "right": "10px", "top": "2px" }}></span>
            <input
              type="text"
              name="findContact-2"
              id="findContact-2"
              className="form-control"
              placeholder="Tüm Departmanlar"
              onChange={(e) => this.handleDepartmentSearch(e)}
              value={
                this.state.searchOtosanDepartmentsTerm === "all"
                  ? ""
                  : this.state.searchOtosanDepartmentsTerm
              }
              autoComplete="off"
              onFocus={(e) => this.handleOtosanDepartmentComboFocus(e, true)}
            />
            {this.renderOtosanDistinctDepartments()}
          </div>
        </div>
      );
    }
  };

  // renderManager =(manager) => {
  //   return (

  //   )
  // }

  handleSelectManager = (id) => {
    this.setState({
      selectedManager: id,
      activePage: 1,
    });
  };

  renderManagerList = (tabName) => {
    // if (!this.props.guide.data) return null;
    // if (this.state.currentTab !== tabName) return null;
    return (
      <GuideManagers
        data={this.props.guide.data}
        onSelectManager={(mgrId) => this.handleSelectManager(mgrId)}
        isOtosanContact={this.state.isOtosanContact}
        getContact={this.getContact}
        selectedManager={this.state.selectedManager}
        searchTerm={this.state.searchTerm}
      />
    );
  };

  renderData = () => {
    let start = this.settings.itemsPerPage * (this.state.activePage - 1);
    let end = start + this.settings.itemsPerPage;


    if (!this.state.filteredData) {
      return null;
    }




    //

    // let resultCards = <GuideCard
    //   key={mgr.id}
    //   contact={mgr}
    //   getContact={this.getContact(mgr.id)}
    // />
    // return resultCards;

    // return this.state.filteredData.length;


    if (this.state.filteredData.length === 1) {
      //       this.setState({
      //   selectedManager: this.state.filteredData[0].id 
      // });
      let resultCards = <GuideCard
        key={this.state.filteredData[0].id}
        contact={this.getFullContact(this.state.filteredData[0].id)}
        getContact={this.getContact(this.state.filteredData[0].id)}
      />
      return resultCards;
    }





    let selectGuid = this.state.selectedManager;


    if (selectGuid === null) {


      // let resultCards = this.state.filteredData
      //   .slice(start, end)
      //   .map((contact) => {
      //     return (
      //       <GuideCard
      //         key={contact.id}
      //         contact={contact}
      //         getContact={this.getContact}
      //       />
      //     );
      //   });

      // if (this.state.selectedManager) {
      //   let mgr = this.getFullContact(this.state.selectedManager);
      //   resultCards.unshift(
      //     <GuideCard
      //       key={mgr.id}
      //       contact={mgr}
      //       getContact={this.getContact}
      //       isManager="true"
      //     />
      //   );
      // }
      // return resultCards;

      return null;

    }
    else {

      let mgr = this.getFullContact(selectGuid);

      let resultCards = <GuideCard
        key={mgr.id}
        contact={mgr}
        getContact={this.getContact(mgr.id)}
      />
      return resultCards;

    }

  };

  renderFilter = () => {
    if (!this.state.selectedManager && this.state.selectedDepartment === "all")
      return null;
    let contact = this.getFullContact(this.state.selectedManager);
    let dept = this.state.selectedDepartment;

    return (
      <>
        <ul className="fgaBreadcrumb">
          <li>
            <a
              href="#"
              onClick={() =>
                this.setState({
                  selectedManager: null,
                  activePage: 1,
                  filteredData: null,
                  searchOtosanDepartmentsTerm: "all",
                  showOtosanDepartments: false,
                  otosanDepartmentDropdownFocused: false,
                  selectedDepartment: "all",
                })
              }
            >
              {this.state.isOtosanContact ? "Ford Otosan" : "Bayi Personeli"}
            </a>
          </li>
          {dept ? (
            dept !== "all" ? (
              <li>
                <a href="#">{dept}</a>
              </li>
            ) : null
          ) : null}
          {contact ? (
            <li>
              <a href="#">{this.capitalizeEachWord(contact.fullname)}</a>
            </li>
          ) : null}
        </ul>
      </>
    );
  };
  capitalizeEachWord(text) {
    if (!text) return "";

    return text
      .split(" ")
      .map((word) =>
        word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ");
  }
  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTab = (tabName) => {
    return (
      <>
        <div
          className="tab-pane fade show active"
          id="nav-home"
          role="tabpanel"
          aria-labelledby="nav-home-tab"
        >
          <div className="row" style={{ marginRight: "10px" }}>
            <div className="col-xl-5 col-lg-5 col-md-5 p-0 padSides10">
              <div className="row mb-1">
                {this.renderKeywordSearch()}
                {/* {this.renderDepartmentFilter()} */}
              </div>
              {this.renderManagerList(tabName)}
            </div>

            <div
              className="col-xl-7 col-lg-7 col-md-7 p-0" style={{ minHeight: "350px" }}
            // style={{
            //   display: "grid",
            //   gridTemplateRows: "repeat(3, auto)",
            //   gridGap: "20px",
            //   alignContent: "start",
            // }}
            >
              <div style={{ display: "ruby-text" }}
              // style={{
              //   display: "grid",
              //   gridTemplateColumns: "1fr 1fr",
              //   justifyItems: "stretch", borderBottomStyle: "inset"
              // }}
              >
                <div>{this.renderFilter()}</div>
                {/* {this.renderPager()} */}
              </div>
              <div
              // style={{
              //   display: "grid",
              //   gridTemplateColumns: "repeat(auto-fill, minmax(300px,1fr))",
              //   gridGap: "20px",
              // }}
              >
                {this.renderData()}

                {!this.state.selectedManager ? this.nullSplash() : ""}

              </div>
              {/* <div style={{ justifySelf: "end" }}>{this.renderPager()}</div> */}
            </div>
          </div>
        </div>
        <div
          className="tab-pane fade"
          id="nav-profile"
          role="tabpanel"
          aria-labelledby="nav-profile-tab"
        ></div>
      </>
    );
  };


  nullSplash = () => {
    return this.state.filteredData.length !== 1 ? <div className="card" style={{ padding: "20px" }}>
      <center>
        <span className='iconmford fo-icon-account-box' style={{ fontSize: "80px", color: "#2d96cd" }} ></span>
        <br></br>
        <p style={{ color: "rgb(45, 150, 205)", fontWeight: "bold" }}> {this.state.isOtosanContact ? "Ford Otosan" : "Bayi Personeli"}</p> </center>
    </div> : null;
  };


  renderTabbedContent = () => {
    if (!this.state.guideFetched) {
      return null;
    }

    // if (this.props.location.hash) {
    //   if (this.props.location.hash !== this.state.currentTab) {
    //     this.setState({ currentTab: this.props.location.hash });
    //   }
    //   this.props.history.push("/guide");
    // }

    return (
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Tab.Container
          id="nav-tab"
          defaultActiveKey="#general"
          activeKey={this.state.currentTab}
          onSelect={this.handleTabSelected}
        >
          <nav className="scrollNav">
            <Nav variant="tabs" role="tablist">
              <Nav.Item>
                <Nav.Link
                  onClick={() => this.setState({ currentTab: "#personel" })}
                  eventKey="#personel"
                >
                  <span className="iconmford fo-icon-featured-play-list"></span> Bayi
                  Personeli
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  className="nav-item nav-link"
                  onClick={() => this.setState({ currentTab: "#ford-otosan" })}
                  eventKey="#ford-otosan"
                >
                  <span className="iconmford fo-icon-directions-car"></span> Ford Otosan
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </nav>
          <Tab.Content>
            <Tab.Pane eventKey="#personel">
              {this.renderTab("#personel")}
            </Tab.Pane>
            <Tab.Pane eventKey="#ford-otosan">
              {this.renderTab("#ford-otosan")}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    );
  };

  render() {
    return (
      this.state.design === true ?
        <GuidePlatin></GuidePlatin> :
        <section className="profilArea my-3">
          {this.props.spinner}
          <div className="container">
            <div className="row d-none d-sm-none d-md-flex d-lg-flex py-4 topRow align-items-center">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
                <ul className="fgaBreadcrumb" style={{ marginLeft: "10px" }}>
                  <li>
                    <a href="/" style={{ verticalAlign: "middle" }}>
                      <span className="iconmford fo-icon-home"></span>
                    </a>
                  </li>
                  <li>
                    <a href="#" style={{ verticalAlign: "middle" }}>
                      <Trans desc="Şirket Bilgileri">10024</Trans>
                    </a>
                  </li>
                  <li className="active">
                    <Trans desc="Rehber">10032</Trans>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row d-flex d-sm-flex d-md-none d-lg-none py-4 topRow">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-4">
                <div className="profilBaslik"><Trans desc="Profil">10405</Trans></div>
              </div>
            </div>
            <div className="row py-4 bottomRow">{this.renderTabbedContent()}</div>
          </div>
          <input type="hidden" autoComplete="on" />
          {/* <div onClick={() => { this.setState({ design: true }); }}> . </div> */}
        </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
    application: state.application,
    guide: state.guide,
  };
};

export default connect(mapStateToProps, { getGuide, showModal })(
  requireAuth(containsLongRunningProcess(Guide))
);
